module.exports = __webpack_public_path__ + "img/Event_Icon_News_Blue.aa9f99cc.png";